import React from 'react';

export default function ForgotPassword({
  form,
  setForm,
  onSubmit,
  onBackToLogin,
  error,
  loading,
  submitted,
}) {
  if (submitted) {
    return (
      <div className="auth-view">
        <div className="hero">
          <h2>Check your email</h2>
          <p>
            If an account exists for <strong>{form.email}</strong>, you'll receive a password reset link within a minute. The link expires in 1 hour.
          </p>
        </div>
        <button className="auth-toggle" onClick={onBackToLogin}>
          ← Back to sign in
        </button>
      </div>
    );
  }

  return (
    <div className="auth-view">
      <div className="hero">
        <h2>Reset your password</h2>
        <p>Enter your email and we'll send you a link to set a new password.</p>
      </div>

      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-field">
          <label>Email</label>
          <input
            type="email"
            autoComplete="email"
            placeholder="you@company.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
        </div>

        {error && (
          <div className="error-message">
            <span></span> {error}
          </div>
        )}

        <button type="submit" className="generate-btn ready" disabled={loading}>
          <span className="btn-icon"></span>
          <span className="btn-text">{loading ? 'Sending…' : 'Send reset link'}</span>
        </button>
      </form>

      <button className="auth-toggle" onClick={onBackToLogin}>
        ← Back to sign in
      </button>
    </div>
  );
}
